const dark = {
  title: 'dark',

  colors: {
    background: '#2D3748',
    text: '#FFF',

    asideBackground: '#322659',
    asideColor: '#FFF',
    strongColor: '#FFF',
    formInputBg: '#718096',
    formInputBorder: '#a8a8b3',

    createRoomBackground: '#63171B',
    createRoomColor: '#FFF',

    separatorColor: '#a8a8b3',
    separatorBefore: '#a8a8b3',
    separatorAfter: '#a8a8b3',

    pColor: '#FFF',
    aColor: '#D53F8C',
    questionBoxBg: '#4A5568',
    highlighted: '#718096',
    answered: '#1A202C',
  }
}

export default dark;